const applyConfig = (config) => {
  config.blocks.blocksConfig.__grid.gridAllowedBlocks = ['teaser', 'image', 'slate', '__iskra-card', '__iskra-about-card', '__iskra-group'];
  config.blocks.blocksConfig.gridBlock.restricted = true;
  return config;
};

export default applyConfig;
